import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { alphaList } from "../../utils/functions";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function ListeMutuelles() {
  const [mutuelles, setMutuelles] = useState([]);

  useEffect(() => {
    function getMutuelles() {
      axios
        .get(`${API_URL}/api/mutuelles`)
        .then((res) => res.data)
        .then((data) => {
          setMutuelles(alphaList(data));
        });
    }

    getMutuelles();
  }, []);

  return (
    <div className="listeMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Liste des mutuelles</title>
      </Helmet>
      <h1>Liste des mutuelles</h1>
      <ul className="listContainer">
        {mutuelles ? (
          Object.keys(mutuelles).map((key) => (
            <div className="oneLetterContainer">
              <h2>{key}</h2>
              {mutuelles[key].map((mutuelle) => (
                <li key={mutuelle.id}>
                  <Link to={`/mutuelles/${mutuelle.id}`}>{mutuelle.nom}</Link>
                </li>
              ))}
            </div>
          ))
        ) : (
          <li>Loading</li>
        )}
      </ul>
    </div>
  );
}

export default ListeMutuelles;
